// @ts-nocheck
import axios from "axios"
import type { AxiosRequestConfig, AxiosResponse } from "axios"
import { store } from "@bapp/webcore"
import loginState from "@states/login/loginstate"
import { API_URLS } from "@constants/api"


const httpAuthorizationErrorCode = 401
const httpForbiddenErrorCode = 403
const API_BASE_URL = API_URLS.BSA_MKY

const LDAP_API = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "text/xml"
  }
})

const setupAxiosInterceptors = () => {
  const onRequest = (config: AxiosRequestConfig) => {
    const loginStateStore = store?.getState().loginState
    if (typeof config.url === "undefined" || config.url === null) {
    
      config.url = API_BASE_URL
    }
    if (
      loginStateStore?.access_token !== "" &&
      !config.url.includes("/token") /* &&
      !config.exceptionForHeader */
    ) {
      //config.headers.Authorization = `Bearer ${loginStateStore.access_token}`
    }
    config.timeout = 60000
    return config
  }

  const onResponseSuccess = (response: AxiosResponse) => {
    return response
  }

  const onResponseError = (error: any) => {
    const statusCode = error.response ? error.response.status : 0
    const loginStateStore = store?.getState().loginState

    // global error handling

    if (error.status === httpForbiddenErrorCode || statusCode === httpAuthorizationErrorCode) {
      if (loginStateStore?.access_token !== "") {
        loginState.logout()
      }
    }

    return Promise.reject(error.message)
  }

  LDAP_API.interceptors.request.use(onRequest)
  LDAP_API.interceptors.response.use(onResponseSuccess, onResponseError)
}

export default setupAxiosInterceptors

export { LDAP_API }
